import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-exclamation",
  "use": "circle-exclamation-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"circle-exclamation\"><path d=\"M9 9V4H8v5h1zm-.5 1a.5.5 0 100 1 .5.5 0 000-1z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 7.5a7.5 7.5 0 1015 0 7.5 7.5 0 00-15 0zm14 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol